import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface GrowthData {
  currentCount: number;
  previousCount: number;
  growthPercentage: number;
  growthAbsolute: number;
}

export const useMemberGrowth = () => {
  const [growth, setGrowth] = useState<GrowthData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGrowth = async () => {
      try {
        const { data, error } = await supabase.rpc('calculate_member_growth');
        
        if (error) {
          console.error('Error fetching member growth:', error);
          return;
        }

        if (data && typeof data === 'object') {
          const growthData = data as any;
          const calculatedGrowth = {
            currentCount: growthData.current_count || 0,
            previousCount: growthData.previous_count || 0,
            growthPercentage: growthData.growth_percentage || 0,
            growthAbsolute: growthData.growth_absolute || 0
          };
          console.log('📈 Member Growth - Data:', calculatedGrowth);
          setGrowth(calculatedGrowth);
        }
      } catch (error) {
        console.error('Error in useMemberGrowth:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchGrowth();
  }, []);

  return { growth, loading };
};
